// This file is auto-generated. Do not edit manually.
export const VERSION_INFO = {
  "commitHash": "8bf1889c7c0591845ec0495eaf279f01b6062767",
  "commitHashShort": "8bf1889",
  "commitDate": "2026-11-03 13:31:56 -0500",
  "buildDate": "2026-11-03T18:35:40.651Z",
  "isDirty": true
};
